import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"
import { useMarina } from "src/contexts/MarinaContext"
import { validatePrecision } from "src/main/PointOfSale/CurrentSalePanel/validators"
import FuelPriceAlertBanner from "src/main/Settings/PublicProfile/Fuel/FuelPriceAlertBanner"

import Form from "src/components/Form"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"

const FuelRatesForm = ({
  ratesHeader,
  fuelOptions,
  currentFuelPriceRequestCount,
  fuelPricesStale,
  showAlertBanner,
  setShowAlertBanner,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const { currencySymbol } = useMarina()

  return (
    <div className="mb-6">
      <HeadingSectionHeader>{ratesHeader}</HeadingSectionHeader>
      <FuelPriceAlertBanner
        currentFuelPriceRequestCount={currentFuelPriceRequestCount}
        fuelPricesStale={fuelPricesStale}
        showAlertBanner={showAlertBanner}
        setShowAlertBanner={setShowAlertBanner}
        location="settings-public-profile"
      />
      <div className="mt-4 grid grid-cols-12 gap-4 px-2">
        {fuelOptions.map((fuelOption) => (
          <div key={fuelOption.label} className="col-span-12 sm:col-span-6">
            <Form.Label htmlFor={`fuelOptions.${fuelOption.label}`}>
              {fuelOption.label}
            </Form.Label>
            <Form.IconTextField
              id={`fuelOptions.${fuelOption.label}`}
              position="left"
              icon={currencySymbol}
              {...register(`fuelOptions.${fuelOption.label}`, {
                validate: validatePrecision({
                  name: "Price",
                  precision: 4,
                }),
                min: {
                  value: 0,
                  message: `Price cannot be less than ${currencySymbol}0.00`,
                },
              })}
              type="number"
              inputMode="decimal"
              hasErrors={!!errors?.fuelOptions?.[fuelOption.label]}
            />
            <Form.Error>
              {errors?.fuelOptions?.[fuelOption.label]?.message}
            </Form.Error>
          </div>
        ))}
      </div>
    </div>
  )
}

FuelRatesForm.propTypes = {
  ratesHeader: PropTypes.string.isRequired,
  fuelOptions: PropTypes.array.isRequired,
  currentFuelPriceRequestCount: PropTypes.number.isRequired,
  fuelPricesStale: PropTypes.bool,
  showAlertBanner: PropTypes.bool.isRequired,
  setShowAlertBanner: PropTypes.func.isRequired,
}

export default FuelRatesForm
